import { COUPONS_ENDPOINTS } from './endpoints.js';
/**
 * Coupons API Client
 * Encapsulates all coupons-related API calls.
 */
export class CouponsClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get the current user's available coupons.
     * Corresponds to: GET /api/coupons/available
     */
    async getAvailableCoupons() {
        const response = await this.httpClient.get(COUPONS_ENDPOINTS.GET_AVAILABLE);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to get available coupons');
        }
        return response.data;
    }
}
//# sourceMappingURL=client.js.map